import { render, staticRenderFns } from "./check-status.vue?vue&type=template&id=0b186718"
import script from "./check-status.vue?vue&type=script&lang=js"
export * from "./check-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports